const primaryFleetManager = {
  all: ['create', 'destroy', 'edit', 'read', 'update', 'view', 'view_form'],
  vehicle: ['edit', 'upload', 'export'],
  driver: {
    can: ['activate', 'deactivate', 'edit', 'upload', 'export', 'invite'],
    cannot: ['read_all_columns'],
  },
  restrictedDriver: ['create', 'edit', 'upload'],
  vehicleForm: ['read_vehicle_location', 'read_vehicle_name', 'read_vehicle_type'],
  billing: {
    can: ['deactivate'],
  },
  RestrictedDriverUpload: {
    can: ['bulkDriverUpload'],
  },
};

export default primaryFleetManager;
